import type { LanguageId } from '../types/execution'

export interface LanguageDefinition {
  id: LanguageId
  label: string
  extension: string
  color: string
  description: string
  sample: string
  stdin: string
}

const whitespacePush = (value: number) => `   ${value.toString(2).replaceAll('0', ' ').replaceAll('1', '\t')}\n`
const whitespaceHello = [...'Hello World!\n'].map((character) => `${whitespacePush(character.codePointAt(0)!)}\t\n  `).join('') + '\n\n\n'

export const languages: LanguageDefinition[] = [
  {
    id: 'c',
    label: 'C',
    extension: 'main.c',
    color: '#8b9eff',
    description: 'Clang WASM + WASI（GNU C17）',
    sample: `#include <stdio.h>

int square(int value) {
  return value * value;
}

int main(void) {
  puts("Hello from C + WASM!");

  for (int i = 1; i <= 5; i++) {
    printf("%d² = %d\\n", i, square(i));
  }

  return 0;
}`,
    stdin: '',
  },
  {
    id: 'javascript',
    label: 'JavaScript',
    extension: 'main.js',
    color: '#f4d35e',
    description: 'WASM検査 + 隔離Worker',
    sample: `const languages = ['Whitespace', 'C', 'JavaScript']

console.log('Hello from JavaScript!')
console.table(
  languages.map((name, index) => ({
    id: index + 1,
    language: name,
    ready: true,
  })),
)

const answer = languages
  .map((name) => name.length)
  .reduce((sum, length) => sum + length, 0)

console.log({ answer })`,
    stdin: '',
  },
  {
    id: 'react',
    label: 'React',
    extension: 'App.jsx',
    color: '#61dafb',
    description: 'JSX変換 + Reactプレビュー',
    sample: `import { useState } from 'react'

function App() {
  const [count] = useState(3)
  const topics = ['JSX', 'Components', 'Hooks']

  return (
    <main style={{ fontFamily: 'system-ui', padding: 32 }}>
      <h1>Hello from React!</h1>
      <p>Count: {count}</p>
      <ul>
        {topics.map((topic) => <li key={topic}>{topic}</li>)}
      </ul>
    </main>
  )
}

render(<App />)`,
    stdin: '',
  },
  {
    id: 'whitespace',
    label: 'Whitespace',
    extension: 'hello.ws',
    color: '#d8b4fe',
    description: 'Rust製スタックVM',
    sample: whitespaceHello,
    stdin: '',
  },
]

export const languageMap = Object.fromEntries(languages.map((language) => [language.id, language])) as Record<LanguageId, LanguageDefinition>
